import React from 'react'
import { Component } from 'reflux'
import { toast } from 'react-toastify'
import { PurchaseOrderStore, PurchaseOrderStoreActions, STATUS } from '../../stores/purchaseOrderStore'
import PurchaseOrderForm from './purchaseOrderForm'

export default class PurchaseOrderCreate extends Component {
  constructor(props) {
    super(props)
    this.stores = [PurchaseOrderStore]
    this.storeKeys = ['status']
  }
  componentDidMount() {
    //PurchaseOrderStoreActions.createEmptyStockLocation()
  }
  componentDidUpdate() {
    if (this.state.status === STATUS.UPDATE_SUCCESS) {
      toast.success('Purchase Order Created', {
        autoClose: 3000,
        onClose: () => {
          PurchaseOrderStoreActions.clearFormToast()
        }
      })
      PurchaseOrderStoreActions.clearFormToast(STATUS.REDIRECT)
    }
    if (this.state.status === STATUS.UPDATE_ERROR) {
      toast.error('Purchase Order Create Failed', {
        autoClose: 3000,
        onClose: () => {
          PurchaseOrderStoreActions.clearFormToast()
        }
      })
      PurchaseOrderStoreActions.clearFormToast(STATUS.REDIRECT)
    }
  }

  render() {
    return (
      <React.Fragment>
        <PurchaseOrderForm />
      </React.Fragment>
    )
  }
}
